import HeroSubSection from "@components/BasicComponents/FullWidthHeader/HeroSubSection"
import {getHeroBlogContent} from "@helpers/getHeroBlogContent"
import {
	BlogPostModuleType,
	HeroModuleType,
} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyTypes"
import {motion} from "framer-motion"
import React from "react"

import HeroCommonGraphic from "./HeroCommonGraphic"
import HeroMain from "./HeroMain"
import styles from "./HomeHeroAnimated.module.scss"

interface HeroSlideContentProps {
	heroItem: HeroModuleType
	textColor: "black" | "white"
	titleStyle?: string
	backgroundColor: string
	currentIndex: number
	showCommonGraphic?: boolean
	featuredPost?: BlogPostModuleType
}

const HeroSlideContent: React.FC<HeroSlideContentProps> = ({
	heroItem,
	textColor,
	titleStyle = "",
	backgroundColor,
	currentIndex,
	showCommonGraphic = false,
	featuredPost,
}) => {
	// in CMS, the initial order of slide 1 is switched to be after slide 2, hence this logic
	// to make sure each slide's styling remains unchanged
	const styleIndex =
		currentIndex === 0 ? 1 : currentIndex === 1 ? 0 : currentIndex
	const hasWhiteBase = true

	return (
		<motion.div
			animate={hasWhiteBase ? undefined : {backgroundColor}}
			initial={false}
			style={{
				position: "relative",
				// borderRadius: "25px",
				backgroundColor: hasWhiteBase ? "#ffffff" : undefined,
				backgroundImage: backgroundColor,
				overflow: "hidden",
			}}
			transition={{duration: 0.6, ease: "easeInOut"}}
		>
			{showCommonGraphic && (
				<HeroCommonGraphic colorBurn={currentIndex !== 1} />
			)}
			<div
				className={styles.contentBox}
				style={{position: "relative", zIndex: 5, color: textColor}}
			>
				<HeroMain
					currentIndex={currentIndex}
					heroItem={heroItem}
					styleIndex={styleIndex}
					titleStyle={titleStyle}
				/>
				<HeroSubSection
					items={getHeroBlogContent(
						heroItem.heroSubSection,
						featuredPost,
					)}
					theme={
						currentIndex === 2
							? "studio"
							: currentIndex === 0
							? "slide1"
							: currentIndex === 1
							? "slide2"
							: undefined
					}
				/>
			</div>
		</motion.div>
	)
}

export default HeroSlideContent
